import {
  TrendingUp,
  Server,
  Megaphone,
  User,
  UserRound,
  Users,
  Brain,
  Sparkles,
  SquareUser,
  CircleUser,
  Star,
  MessageCircle,
  Image,
  FileText,
  Film,
  Camera,
  ListChecks,
  Zap,
  Rss,
  type LucideIcon,
} from 'lucide-react';

export const ICONS: Record<string, LucideIcon> = {
  'trending-up': TrendingUp,
  server: Server,
  megaphone: Megaphone,
  user: User,
  'user-round': UserRound,
  users: Users,
  brain: Brain,
  sparkles: Sparkles,
  'square-user': SquareUser,
  'circle-user': CircleUser,
  star: Star,
  'message-circle': MessageCircle,
  image: Image,
  'file-text': FileText,
  film: Film,
  camera: Camera,
  'list-checks': ListChecks,
  zap: Zap,
  rss: Rss,
};

export const AVATAR_SYMBOL_CHOICES = [
  'message-circle',
  'megaphone',
  'trending-up',
  'server',
  'users',
  'sparkles',
  'brain',
  'rss',
];

export const PROFILE_SYMBOL_CHOICES = ['circle-user', 'user-round', 'user', 'users', 'sparkles', 'star'];

export const ATTACHMENT_SYMBOL_CHOICES = ['image', 'file-text', 'film', 'camera', 'sparkles', 'list-checks'];

export function resolveIcon(symbol: string): LucideIcon {
  return ICONS[symbol] ?? Sparkles;
}
